import { useContext } from 'react';

import { OverlayContext } from './OverlayProvider';
import OverlayRenderer from './OverlayRenderer';

const OverlaysRenderer = () => {
  const { overlays } = useContext(OverlayContext);

  return (
    <>
      {overlays.map((overlay) => (
        <OverlayRenderer key={overlay.id} data={overlay} />
      ))}
    </>
  );
};

export default OverlaysRenderer;
